import api from "./api";
import { TipoChavePix } from "./tipos";

export interface AfiliacaoDto {
    id: string;
    codigo: string;
    link: string;
    ativo: boolean;
    saldo: number;
}

export interface IndicacaoDto {
    nomeEmpresaIndicada: string;
    dataCadastro: string;
    status: string;
    dataAssinatura?: string | null;
    valorCashback: number;
}

export interface MovimentoCarteiraDto {
    data: string;
    tipo: string;
    valor: number;
    descricao: string;
}

export interface SolicitacaoSaqueDto {
    id: string;
    idEmpresa: string;
    nomeEmpresa: string;
    valor: number;
    chavePix: string;
    status: string;
    dataSolicitacao: string;
    motivoRejeicao?: string | null;
}

export interface SolicitarSaqueRequest {
    valor: number;
    chavePix: string;
    tipoChavePix: TipoChavePix;
}

export const obterAfiliacao = (idEmpresa: string) =>
    api.get<AfiliacaoDto>(`/AfiliacaoPorEmpresa/${idEmpresa}`);

export const gerarLink = (idEmpresa: string, baseUrl?: string) =>
    api.post<AfiliacaoDto>(
        `/Afiliacao/GerarLink/${idEmpresa}`,
        null,
        baseUrl ? { params: { baseUrl } } : undefined
    );

export const excluirLink = (idEmpresa: string) =>
    api.delete(`/Afiliacao/${idEmpresa}`);

export const listarIndicacoes = (idEmpresa: string) =>
    api.get<IndicacaoDto[]>(`/Afiliacao/Indicacoes/${idEmpresa}`);

export const listarExtrato = (idEmpresa: string) =>
    api.get<MovimentoCarteiraDto[]>(`/Afiliacao/Extrato/${idEmpresa}`);

export const listarSaques = (idEmpresa: string) =>
    api.get<SolicitacaoSaqueDto[]>(`/Afiliacao/Saques/${idEmpresa}`);

export const solicitarSaque = (idEmpresa: string, idUsuario: string, dados: SolicitarSaqueRequest) =>
    api.post<SolicitacaoSaqueDto>(`/Afiliacao/SolicitarSaque/${idEmpresa}/${idUsuario}`, dados);

export const listarSaquesPendentes = () =>
    api.get<SolicitacaoSaqueDto[]>(`/Afiliacao/Saques/Pendentes`);

export const aprovarSaque = (id: string) =>
    api.post(`/Afiliacao/Saques/${id}/Aprovar`);

export const rejeitarSaque = (id: string, motivo: string) =>
    api.post(`/Afiliacao/Saques/${id}/Rejeitar`, JSON.stringify(motivo), {
        headers: { "Content-Type": "application/json" },
    });

export const listarSaquesReconciliacao = () =>
    api.get<SolicitacaoSaqueDto[]>(`/Afiliacao/Saques/Reconciliacao`);

export const confirmarPagoSaque = (id: string) =>
    api.post(`/Afiliacao/Saques/${id}/ConfirmarPago`);

export const estornarSaque = (id: string, motivo: string) =>
    api.post(`/Afiliacao/Saques/${id}/Estornar`, JSON.stringify(motivo), {
        headers: { "Content-Type": "application/json" },
    });
